module.exports = __webpack_public_path__ + "img/engineering-badge.916d6385.png";